import { BigButton } from '@components/buttons/bigButton'
import { SimpleModalProps } from '../simpleModal'
import './setupSlideModal.css'
import Modal from 'react-modal'
import { useTranslator } from '@components/translator/hook'
import { DownloadButton } from '@components/buttons/downloadButton'
import { useProject } from '@components/project/hook'
import { LinkageButtonSetupSlide } from '@components/linkage/linkageButtonSetupSlide'
import Accordion from '@components/accordion/Accordion'

interface SetupSlideModalProps extends Pick<SimpleModalProps, 'onClose'> {
  isOpen: boolean
}

export const SetupSlideModal: React.FC<SetupSlideModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslator()
  const { canEdit } = useProject()

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="セットアップスライド"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      shouldFocusAfterRender={false}
      shouldReturnFocusAfterClose={false}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 862,
        },
      }}
    >
      <iframe
        src="https://docs.google.com/presentation/d/e/2PACX-1vT6NxVaF0aeLKQ7omQZ__HvUpOnYv6rctQbakGEfnEmTHRqAZyvRl-if4HLv8JtP17MC5RoyiGrJxU-/embed?start=false&loop=false&delayms=3000"
        className="roblox-setup-slide"
        allowFullScreen={true}
      />

      {canEdit ?
        <Accordion>
          <div className="setup-slide-modal-footer">
            <div className="setup-slide-modal-buttons">
              {t('description_setup_buttons')}
              <DownloadButton useDownloadModal={false} />
              <LinkageButtonSetupSlide />
            </div>
            <BigButton className="end-setup-button" onClick={onClose}>
              {t('end_setup')}
            </BigButton>
            <div className="setup-help-link-group">
              <div className="setup-help-link">
                {t('setup_help_link_prefix')}
                <a
                  href="https://dso-support.zendesk.com/hc/ja/articles/29893678034583"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('setup_help_link_text')}
                </a>
                {t('setup_help_link_suffix')}
              </div>
              <div className="setup-help-link">
                {t('setup_contact_prefix')}
                <a href="mailto:online@digitane.jp" rel="noopener noreferrer">
                  online@digitane.jp
                </a>
                {t('setup_contact_suffix')}
              </div>
            </div>
          </div>
        </Accordion>
      : <div className="setup-slide-modal-footer">
          <BigButton onClick={onClose}>{t('close_button')}</BigButton>
        </div>
      }
    </Modal>
  )
}
